import React from 'react'
import styled from 'styled-components'

const PlayButton = ({
    content,
    color = "success",
    action,
    disabled
}) => {
    return (
        <PlayBtn 
            className={color}
            onClick={action}
            disabled={disabled}
        >
            {content}
        </PlayBtn>
    )
}

export default PlayButton

const PlayBtn = styled.button`
    width: 90%;
    max-width: 100px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    border: 0;
    background-color: rgb(255, 56, 86);
    letter-spacing: 1.5px;
    font-size: 15px;
    transition: all .3s ease;
    box-shadow: rgb(201, 46, 70) 0px 7px 0px 0px;
    color: hsl(0, 0%, 100%);
    cursor: pointer;
    outline: none;
    
    
    &.success {
        background-color: #2ECC71;
        box-shadow: #239B56 0px 7px 0px 0px;
    }
    &.error {
        background-color: #FF3856;
        box-shadow: #C92E46 0px 7px 0px 0px;
    }
    &.info {
        background-color: #3498DB;
        box-shadow: #2E86C1 0px 7px 0px 0px;
    }
    &.danger {
        background-color: #D62222;
        box-shadow: #AB0000 0px 7px 0px 0px;
    }
    &:active {
        &.success {
            background-color: #2ECC71;
            box-shadow: #239B56 0px 0px 0px 0px;
        }
        &.error {
            background-color: #FF3856;
            box-shadow: #C92E46 0px 0px 0px 0px;
        }
        &.info {
            background-color: #3498DB;
            box-shadow: #2E86C1 0px 0px 0px 0px;
        }
        &.danger {
            background-color: #D62222;
            box-shadow: #AB0000 0px 0px 0px 0px;
        }
        transform: translateY(5px);
        transition: 200ms;
    }
    &:disabled {
        background-color: #B9B9B9;
        box-shadow: #939393 2px 5px 0px 0px;
        &.success {
            background-color: #B9B9B9;
            box-shadow: #939393 2px 5px 0px 0px;
        }
        &.error {
            background-color: #B9B9B9;
            box-shadow: #939393 2px 5px 0px 0px;
        }
        &.info {
            background-color: #B9B9B9;
            box-shadow: #939393 2px 5px 0px 0px;
        }
        &.danger {
            background-color: #B9B9B9;
            box-shadow: #939393 2px 5px 0px 0px;
        }
        transform: translateY(0px);
    }
`